module.exports = __webpack_public_path__ + "img/Rotation.0da75e15.png";